import { render, staticRenderFns } from "./PerfisAcesso.vue?vue&type=template&id=27f272cd&"
import script from "./PerfisAcesso.vue?vue&type=script&lang=js&"
export * from "./PerfisAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports